import { StatusTypes } from './types';

export const AmeliproStatusTypes: StatusTypes = {
	action: {
		defaultLabel: 'A finaliser',
		bgColor: 'ap-blue lighten-1'
	},
	archive: {
		defaultLabel: 'Archivé',
		bgColor: 'ap-grey lighten-2'
	},
	canceled: {
		defaultLabel: 'Annulé',
		borderColor: 'ap-grey lighten-1'
	},
	closed: {
		defaultLabel: 'Clôturé',
		bgColor: 'ap-parme'
	},
	draft: {
		defaultLabel: 'Brouillon',
		bgColor: 'ap-yellow lighten-3'
	},
	failure: {
		defaultLabel: 'Refusé',
		bgColor: 'ap-red lighten-2'
	},
	progress: {
		defaultLabel: 'En cours',
		bgColor: 'ap-red lighten-3'
	},
	success: {
		defaultLabel: 'Validé',
		bgColor: 'ap-green lighten-2'
	}
};
